<template>
    <div class="search-in-google">
      <a class="search-in-google__link" :href="href" target="_blank">
        <base-material-design-icon class="search-in-google__icon" icon="searchWeb" />
      </a>
    </div>
</template>

<script>
export default {
  name: 'BaseSearchInGoogle',
  props: {
    query: {
      type: String,
      require: true
    }
  },
  computed: {
    href () {
      const query = encodeURI(this.query)
      return `https://www.google.com/search?q=${query}`
    }
  }
}
</script>

<style scoped lang="scss">
  .search-in-google {
    display: inline-block;
    cursor: pointer;
    position: absolute;
    padding-right: 15px;

    &__link {
      color: $rfx-dark-march;
      font-size: 16px;

      &:hover {
        color: $rfx-bright-blue !important;
      }

      &:visited {
        color: $rfx-dark-march;
      }
    }

    &__icon {
      font-size: 16px !important;
    }
  }
</style>
